// Debug logger that stores logs and can send them to a file
const logs: string[] = []
const MAX_LOGS = 500

export function debugLog(component: string, message: string, data?: unknown) {
  const timestamp = new Date().toISOString()
  const logEntry = data
    ? `[${timestamp}] [${component}] ${message} ${JSON.stringify(data)}`
    : `[${timestamp}] [${component}] ${message}`

  logs.push(logEntry)
  if (logs.length > MAX_LOGS) logs.shift()

  // Also log to console
  console.log(logEntry)
}

export function getLogs(): string[] {
  return [...logs]
}

export function getLogsAsText(): string {
  return logs.join('\n')
}

export function clearLogs() {
  logs.length = 0
}

// Expose globally for debugging
if (typeof window !== 'undefined') {
  (window as any).__DEBUG_LOGS__ = {
    getLogs,
    getLogsAsText,
    clearLogs,
    downloadLogs: () => {
      const text = getLogsAsText()
      const blob = new Blob([text], { type: 'text/plain' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `debug-logs-${Date.now()}.txt`
      a.click()
      URL.revokeObjectURL(url)
    }
  }
}
